import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React from 'react'

import {useAccordion} from './Accordion'
import {classes} from './Accordion.classes'

type TProps = React.PropsWithChildren<{expandIcon?: React.ReactNode}>

export const AccordionSummary: React.FC<TProps> = ({children, expandIcon}) => {
  const {expanded, toggle} = useAccordion()

  return (
    <Grid
      alignItems="center"
      className={clsx(classes.summary, expanded && classes.summaryExpanded)}
      component="button"
      container
      data-details-accordion-summary
      onClick={toggle}
      wrap="nowrap"
    >
      {children}
      <div className={clsx(classes.expandIcon, expanded && classes.iconExpanded)}>{expandIcon ? expandIcon : null}</div>
    </Grid>
  )
}
